<script setup>
const props = defineProps({
  items: { type: Array, default: () => ([]) },
})

const topCategories = (categories) => categories.filter(v => !v.parent_id)
</script>

<template>
  <div
    v-if="items?.length"
    class="grid grid-cols-1 lg:grid-cols-2 items-start gap-x-3 gap-y-12"
  >
    <NuxtLink
      v-for="(item, i) of items"
      :key="i"
      :to="'/producer/'+item.cuid"
      class="grid grid-cols-2 gap-x-2 gap-y-2 !no-underline"
      :style="{
        border: 'none !important'
      }"
    >
      <div
        class="relative w-1/2 rounded-lg aspect-square"
        :class="item.catch_copy ? '' : 'mx-auto col-span-full'"
      >
        <NuxtImg
          class="absolute -top-3 -left-1"
          width="50px"
          src="/icon/new-icon.png"
        />
        <NuxtImg
          :src="item.image_files?.length ? encodeURI(item.image_files[0].url) : '/noimage.png'"
          class="block rounded-lg aspect-square"
          :style="{
            objectFit: 'cover',
            objectPosition: 'center',
          }"
        />
      </div>

      <div v-if="item.catch_copy">
        <p class="text-lg font-noto-serif" v-if="item.browsed">{{ item.name }}</p>
        <p class="py-3" v-if="item.catch_copy">{{ item.catch_copy }}</p>
      </div>

      <div
        v-if="topCategories(item.categories)?.length"
        class="col-span-full flex gap-x-2 gap-y-1 h-min"
      >
        <span
          v-for="(category, c) of topCategories(item.categories)"
          :key="c"
          class="badge badge-zinc badge-sm badge-pill badge-outlined"
        >{{ category.name }}</span>
      </div>

      <dl class="col-span-full grid grid-cols-4 sm:grid-cols-5 py-2 border border-zinc-400 rounded-lg border-dashed">
        <dt class="px-2 py-1 border-b-2 border-dashed">
          <span class="!text-xs badge badge-pill badge-sm w-full badge-primary">地域</span>
        </dt>
        <dd class="col-span-3 sm:col-span-4 px-2 py-2 border-b-2 border-dashed text-sm">{{ item.prefecture }}/{{ item.address1 }}</dd>
        <dt class="px-2 py-1 border-b-2 border-dashed">
          <span class="!text-xs badge badge-pill badge-sm w-full badge-primary">取扱品目</span>
        </dt>
        <dd class="col-span-3 sm:col-span-4 px-2 py-2 border-b-2 border-dashed text-sm">{{ item.product_detail }}</dd>
      </dl>
    </NuxtLink>
  </div>

  <p
    v-else
    class="text-center text-xl font-noto-serif mt-0 lg:mt-16"
  >新着生産者はありません。</p>

</template>